<template>
  <div>
    <div class="graph-selector mb-2">
      <div
        class="btn-toolbar d-flex justify-content-center mt-2"
        role="toolbar"
        aria-label="Bar selector"
      >
        <div
          class="btn-group btn-group-sm"
          role="group"
          style="z-index: 0"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="
            disabled ? $t('categoryDetails.tooltip.noHistoryForQuestion') : ''
          "
        >
          <button
            :disabled="disabled"
            type="button"
            class="btn"
            :class="flipped ? 'btn-secondary' : 'btn-primary btn-active'"
            @click="flipped = false"
          >
            <i
              :class="`bi bi-bar-chart-fill fs-5 p-0 ${
                flipped ? 'text-dark' : 'text-light'
              }`"
            ></i>
          </button>
          <button
            :disabled="disabled"
            type="button"
            class="btn"
            :class="!flipped ? 'btn-secondary' : 'btn-primary btn-active'"
            @click="flipped = true"
          >
            <i
              :class="`bi bi-graph-up fs-5 p-0 ${
                flipped ? 'text-light' : 'text-dark'
              }`"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionDetailsFlipper',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      flipped: null
    }
  },
  computed: {
    atLeastOneQuestionHasTrend() {
      return this.question.averages.some((average) => average.trend !== null)
    }
  },
  watch: {
    flipped(newValue) {
      this.$emit('update:modelValue', newValue)
    }
  }
}
</script>
